export const stepsJson = [
  {
    steps_id: 1,
    text: "Business Profile",
  },
  {
    steps_id: 2,
    text: "Representative Details",
  },
  {
    steps_id: 3,
    text: "Bank Details",
  },
  {
    steps_id: 4,
    text: "Document Upload",
  },
];
